import api from "../lib/axios";

// fetch speaker data
export const getSpeakerData = async (eventId) => {
  const res = await api.get(`/speaker/getSpeakers?event_id=${eventId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  const status = res.status;
  const data = res.data?.data?.speakers || [];
  return { status, data };
};

export const updateSpeakerPositionForEvent = async (eventId, token, data) => {
  const headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const res = await api.put(
    `/speaker/position/${eventId}`,
    { data },
    { headers },
  );
  return res;
};

export const deleteSpeaker = async (speakerId, token) => {
  const res = await api.delete(`/speaker/deleteSpeaker/${speakerId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res;
};

export const deleteSpeakerTeam = async (data, id, token) => {
  const res = await api.post(`/speaker/deleteSpeakerTeam`, { data, id }, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const getSpeakers = async (eventId) => {
  const res = await api.get(`/speaker/getSpeakers?event_id=${eventId}`);
  return res;
};

export const deleteSpeaker2 = async (speakerId, reason) => {
  const res = await api.delete(`/speaker/deleteSpeaker/${speakerId}`, {
    data: { delete_reason: reason },
  });
  return res;
};

export const updateSpeaker = async (id, formData, token) => {
  const res = await api.put(`/speaker/updateSpeaker/${id}`, formData, {
    headers: { Authorization: `Bearer ${token}` },
    transformRequest: [(d) => d],
  });
  return res;
};

export const updateSpeakerTeam = async (member, token) => {
  const res = await api.put(`/speaker/updateSpeakerTeam`, member, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res;
};

export const createSpeakers = async (formData, token) => {
  const res = await api.post(`/speaker/createSpeakers`, formData, {
    headers: { Authorization: `Bearer ${token}` },
    transformRequest: [(d) => d],
  });
  return res;
};
